const Header = () => null;

export default Header;
